<template>
    <div class="w-100">
        <b-btn @click="modalShow = !modalShow" variant="primary" size="sm" class="float-right mb-3">
            <i class="fas fa-file-upload mr-1"></i>
            {{ $t('button.UploadPaymentLog') }}
        </b-btn>
        <b-modal
                ref="createModal"
                :no-close-on-backdrop="true"
                size="lg"
                :title="$t('button.UploadPaymentLog')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-left">
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <div class="form-group">
                    <label for="file">{{$t('fields.File')}}</label>
                    <input type="file" class="form-control-file" id="file" ref="file">
                </div>
            </div>

            <div slot="modal-footer" class="w-100 text-right">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >
                    {{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="primary"
                        @click="submit"
                        :disabled="disabled"
                >
                    {{$t('button.Upload')}}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import {ROUTER_NAMES, ERROR_MESSAGES} from '../../constants';

  export default {
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    props: ['eventId'],
    name: "EventsPaymentLogUploadModal",
    data() {
      return {
        modalShow: false,
        disabled: false,
        error: ''
      };
    },
    methods: {
      ...mapActions(['uploadPaymentLog']),
      submit(e) {
        e.preventDefault();
        this.disabled = true;
        const data = {
          file: this.$refs.file.files[0],
          eventId: this.eventId
        };

        this.uploadPaymentLog(data)
          .then(response => {
            this.$router.push({
              name: ROUTER_NAMES.ADMIN_EVENTS
            });
            this.disabled = false;
            this.modalShow = false;
          })
          .catch(() => {
            this.disabled = false;
            this.$router.push({
              name: ROUTER_NAMES.ERROR
            });
          });
  }
    }
  }
</script>

<style scoped>

</style>
